export const DriverRegistrationStep = {
  Profile: 0,
  Documents: 1,
  Complete: 2,
};
